import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect,useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/socialsectors';

    const paths = {
        endpointSave: `${endpointBackend}governanceroom/socialsectors/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/governanceroom/socialsectors/list`,
        pathView: `/governanceroom/socialsectors/view`
    }

    const labels = {
        labelTitleAdd: "Novo Setor Social",
        labelTitleEdit: "Editar Setor Social",
        labelTitleView: 'Visualizar Setor Social'
    }

    const hiddenValues = {}

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id = profileFilter.core_application_instance_id
    }

    const getForm = (values) => {

        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'governance_room_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/cities/getall',
                        label: 'city_name',
                        value: 'city_id',
                        params: {
                            filter: {
                                where: {
                                    profileFilter
                                },
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Nome do Setor Social',
                    validations: {
                      required: true
                    },
                    columnSize: 12,
                },
                values.governance_room_city_id ? {
                    name: 'sectors_social',
                    type: 'multiinput',
                    label: 'Setores Censitários',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'governance_room_sector_id',
                            type: 'select',
                            label: 'Setor',
                            options: [],
                            optionsEndpoint: {
                                endpoint: endpointBackend + 'governanceroom/sectors/getall',
                                label: 'sector_id',
                                value: 'id',
                                params: {
                                    filter: {
                                        city_id: values.governance_room_city_id || ''
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            columnSize: 12
                        },
                    ],
    
                    validations: {
                        required: true,
                    },
                    columnSize: 12
                } : {},
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
            }
            if(profileFilter.core_application_instance_id){
                values.core_application_instance_id = profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
